import React from 'react';
import IdeateWrapper from '../components/IdeateWrapper';

const CatchAllPage = () => <IdeateWrapper />;

export default CatchAllPage;
